import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4 col-xxl-3 d-flex flex-center" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "nav bg-light rounded p-3",
      id: "nav-tab",
      role: "tablist"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link rounded active btn btn-active btn-active-dark fw-bolder btn-color-gray-600 py-3 px-5 me-2",
        id: "kt_nav_monthly",
        "data-bs-toggle": "tab",
        href: "#kt_nav_monthly_content",
        role: "tab",
        "aria-controls": "kt_nav_monthly",
        "aria-selected": "true"
      }, " Monthly "),
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link rounded btn btn-active btn-active-dark fw-bolder btn-color-gray-600 py-3 px-5",
        id: "kt_nav_annually",
        "data-bs-toggle": "tab",
        href: "#kt_nav_annually_content",
        role: "tab",
        "aria-controls": "kt_nav_annually",
        "aria-selected": "false"
      }, " Annually ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 col-lg-12 col-xl-8 col-xxl-9" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "tab-content",
      id: "nav-tabContent"
    }, [
      /*#__PURE__*/_createElementVNode("div", {
        id: "kt_nav_monthly_content",
        class: "tab-pane fade show active",
        role: "tabpanel",
        "aria-labelledby": "kt_nav_monthly"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center px-9 py-12 justify-content-center" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "text-primary fs-3 fw-bolder mb-7" }, "Free"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-5x fw-bold d-flex justify-content-center align-items-start lh-sm" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "align-self-start fs-2 mt-3" }, "$"),
                /*#__PURE__*/_createTextVNode(" 0 ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bolder mb-7" }, "Monthly"),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-light-primary fw-bolder fs-6 py-3 px-8 mx-auto"
              }, "Start")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center px-9 py-12 justify-content-center bg-primary rounded" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-3 fw-bolder mb-7" }, "Pro"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-5x text-white fw-bold d-flex justify-content-center align-items-start lh-sm" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "fs-2 mt-3" }, "$"),
                /*#__PURE__*/_createTextVNode("49 ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-7" }, "Monthly"),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn bg-white bg-opacity-20 bg-hover-white text-hover-primary text-white fw-bolder fs-6 py-3 px-8 mx-auto"
              }, "Start")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center px-9 py-12 justify-content-center" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "text-primary fs-3 fw-bolder mb-7" }, "Lifetime"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-5x fw-bold d-flex justify-content-center align-items-start lh-sm" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "fs-2 mt-3" }, "$"),
                /*#__PURE__*/_createTextVNode("199 ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bolder mb-7" }, "Monthly"),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-light-primary fw-bolder fs-6 py-3 px-8 mx-auto"
              }, "Start")
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        id: "kt_nav_annually_content",
        class: "tab-pane fade",
        role: "tabpanel",
        "aria-labelledby": "kt_nav_annually"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center px-9 py-12 justify-content-center" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "text-primary fs-3 fw-bolder mb-7" }, "Free"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-5x fw-bold d-flex justify-content-center align-items-start lh-sm" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "fs-2 mt-3" }, "$"),
                /*#__PURE__*/_createTextVNode("0 ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bolder mb-7" }, "Annually"),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-light-primary fw-bolder fs-6 py-3 px-8 mx-auto"
              }, "Start")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center px-9 py-12 justify-content-center bg-primary rounded" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-3 fw-bolder mb-7" }, "Pro"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-5x text-white fw-bold d-flex justify-content-center align-items-start lh-sm" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "fs-2 mt-3" }, "$"),
                /*#__PURE__*/_createTextVNode("499 ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-7" }, "Annually"),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn bg-white-opacity-20 bg-hover-white text-hover-primary text-white fw-bolder fs-6 py-3 px-8 mx-auto"
              }, "Start")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-lg-12 col-xl-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center px-9 py-12 justify-content-center" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "text-primary fs-3 fw-bolder mb-7" }, "Lifetime"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-5x fw-bold d-flex justify-content-center align-items-start lh-sm" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "fs-2 mt-3" }, "$"),
                /*#__PURE__*/_createTextVNode("2,299 ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bolder mb-7" }, "Annually"),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-light-primary fw-bolder fs-6 py-3 px-8 mx-auto"
              }, "Start")
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "border-0 p-0" }
const _hoisted_7 = { class: "d-flex bg-light rounded flex-nowrap" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 py-8 px-9 flex-root d-flex align-items-center min-w-150px" }, " Sublicense Visuals ", -1)
const _hoisted_9 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_10 = { class: "bg-white rounded h-40px w-40px d-flex flex-center" }
const _hoisted_11 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_12 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_13 = { class: "bg-white rounded h-40px w-40px d-flex flex-center" }
const _hoisted_14 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_15 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_16 = { class: "bg-white rounded h-40px w-40px d-flex flex-center" }
const _hoisted_17 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_18 = { class: "border-0 p-0" }
const _hoisted_19 = { class: "d-flex flex-nowrap" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 py-8 px-9 flex-root d-flex align-items-center min-w-150px" }, " Free Updates ", -1)
const _hoisted_21 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_22 = { class: "bg-light rounded h-40px w-40px d-flex flex-center" }
const _hoisted_23 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_24 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_25 = { class: "bg-light rounded h-40px w-40px d-flex flex-center" }
const _hoisted_26 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_27 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_28 = { class: "bg-light rounded h-40px w-40px d-flex flex-center" }
const _hoisted_29 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_30 = { class: "border-0 p-0" }
const _hoisted_31 = { class: "d-flex bg-light rounded flex-nowrap" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 py-8 px-9 flex-root d-flex align-items-center min-w-150px" }, " Theme Support ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "py-8 px-9 flex-root" }, null, -1)
const _hoisted_34 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_35 = { class: "bg-white rounded h-40px w-40px d-flex flex-center" }
const _hoisted_36 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_37 = { class: "py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_38 = { class: "bg-white rounded h-40px w-40px d-flex flex-center" }
const _hoisted_39 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_40 = { class: "border-0 p-0" }
const _hoisted_41 = { class: "d-flex flex-nowrap" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 py-8 px-9 flex-root d-flex align-items-center min-w-150px" }, " Unlimited Websites ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "py-8 px-9 flex-root" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "py-8 px-9 flex-root" }, null, -1)
const _hoisted_45 = { class: "fw-bolder fs-3 py-8 px-9 flex-root d-flex justify-content-center" }
const _hoisted_46 = { class: "bg-light rounded h-40px w-40px d-flex flex-center" }
const _hoisted_47 = { class: "svg-icon svg-icon-2 svg-icon-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _hoisted_43,
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}